import React, { useEffect } from 'react'
import {
  Grid,
  Typography
} from '@mui/material'
import PostLogin from '../../../layout/post-login'
import CompanyForm from './add'

const CompanyAdd = (props) => {
  const detail = props.location.state?.detail
  return (
    <PostLogin>
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
      >
        <Grid item>
          <Typography variant='h5' gutterBottom component='h5'>Company Page {detail ? 'Edit' : 'Add'}</Typography>
        </Grid>
      </Grid>

      <CompanyForm
        mode={detail ? 'edit' : 'add'}
        data={detail || {}}
        {...props}
      />
    </PostLogin>
  )
}

export default CompanyAdd
